import React from 'react';
import PropTypes from 'prop-types';
import format from 'string-template';
import { connect } from 'react-redux';
import { change, untouch } from 'redux-form';
import { length, required } from 'redux-form-validators';
import { saveAs } from 'file-saver';

import {
    NAME_LENGTH,
    FIRSTNAME_LENGTH,
    CITY_LENGTH,
    ZIP_CODE_LENGTH,
    ADDRESS_LENGTH
} from '../../../../constants/form';

import { sendDownloadBillRequest } from '../../../../services/ebon/actions';

import {
    LegendFieldComponent,
    TextInputFieldComponent,
    NumberInputFieldComponent
} from '../../../../components/form';

import './DownloadBillFormComponent.Style.js';
import { HTTP_METHOD_POST } from '../../../../constants/httpMethod';
import { API_ROOT } from '../../../../constants';
import { ContactRequestStyledFormComponent } from './DownloadBillFormComponent.Style.js';

const FORM_NAME = 'ebonbilldownload-form';

class DownloadBillFormComponent extends React.Component {
    submit = formData => {
        console.log(formData);
        const { orderId } = this.props;
        let config = {
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json;charset=UTF-8' },
            method: HTTP_METHOD_POST,
            body: JSON.stringify(formData)
        };
        fetch(`${API_ROOT}/public/ebon/order/${orderId}/bill`, config).then(function(response) {
            if (response.ok) {
                response.blob().then(blob => {
                    var file = new Blob([blob], { type: 'application/pdf' });
                    saveAs(file, 'Facture');
                });
            }
        });
    };

    render() {
        const { i18n, i18nFeatureForm, errorMessage } = this.props;

        return (
            <ContactRequestStyledFormComponent
                form={FORM_NAME}
                classNameInputContainer="grid-2 has-gutter"
                onSubmit={this.submit}
                encType
                submitText={i18n.BILL.BUTTON}
                initialValues={{ email: this.props.email, hmac: this.props.hmac }}>
                <TextInputFieldComponent
                    name="lastname"
                    label={i18nFeatureForm.LABEL_LASTNAME}
                    placeholder={i18nFeatureForm.PLACEHOLDER_LASTNAME}
                    isRequired
                    classNameInputContainer="one-half"
                    validate={[
                        required({ msg: i18nFeatureForm.REQUIRED }),
                        length({
                            max: NAME_LENGTH,
                            msg: format(i18nFeatureForm.LASTNAME_SIZE_ERROR, NAME_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="firstname"
                    label={i18nFeatureForm.LABEL_FIRSTNAME}
                    placeholder={i18nFeatureForm.PLACEHOLDER_FIRSTNAME}
                    isRequired
                    classNameInputContainer="one-half"
                    validate={[
                        required({ msg: i18nFeatureForm.REQUIRED }),
                        length({
                            max: FIRSTNAME_LENGTH,
                            msg: format(i18nFeatureForm.FIRSTNAME_SIZE_ERROR, FIRSTNAME_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="address"
                    label={i18nFeatureForm.LABEL_ADDRESS}
                    placeholder={i18nFeatureForm.LABEL_ADDRESS}
                    isRequired
                    classNameInputContainer="full"
                    validate={[
                        required({ msg: i18nFeatureForm.REQUIRED }),
                        length({
                            max: ADDRESS_LENGTH,
                            msg: format(i18nFeatureForm.ADDRESS_SIZE_ERROR, ADDRESS_LENGTH)
                        })
                    ]}
                />
                <TextInputFieldComponent
                    name="city"
                    label={i18nFeatureForm.LABEL_CITY}
                    placeholder={i18nFeatureForm.LABEL_CITY}
                    isRequired
                    classNameInputContainer="one-half"
                    validate={[
                        required({ msg: i18nFeatureForm.REQUIRED }),
                        length({
                            max: CITY_LENGTH,
                            msg: format(i18nFeatureForm.CITY_SIZE_ERROR, CITY_LENGTH)
                        })
                    ]}
                />
                <NumberInputFieldComponent
                    name="postCode"
                    label={i18nFeatureForm.LABEL_ZIPCODE}
                    placeholder={i18nFeatureForm.LABEL_ZIPCODE}
                    isRequired
                    classNameInputContainer="one-half"
                    validate={[
                        required({ msg: i18nFeatureForm.REQUIRED }),
                        length({
                            max: ZIP_CODE_LENGTH,
                            msg: format(i18nFeatureForm.ZIP_CODE_SIZE_ERROR, ZIP_CODE_LENGTH)
                        })
                    ]}
                />

                <LegendFieldComponent classNameInputContainer="full">
                    {i18n.LEGEND_MANDATORY_FIELDS}
                </LegendFieldComponent>

                {errorMessage && (
                    <LegendFieldComponent classNameInputContainer="color-err">
                        {errorMessage}
                    </LegendFieldComponent>
                )}
            </ContactRequestStyledFormComponent>
        );
    }
}

DownloadBillFormComponent.propTypes = {
    i18n: PropTypes.object.isRequired,
    email: PropTypes.string.isRequired,
    orderId: PropTypes.string.isRequired,
    hmac: PropTypes.string.isRequired
};

function mapStateToProps(state) {
    return {
        i18n: state.i18n.page.EBON,
        i18nFeatureForm: state.i18n.feature.form
    };
}

const mapDispatchtoProps = {
    sendDownloadBillRequest,
    change,
    untouch
};

export default connect(mapStateToProps, mapDispatchtoProps)(DownloadBillFormComponent);



// WEBPACK FOOTER //
// ./src/components/pages/ebon/download/DownloadBillFormComponent.js